var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar5 = function SvgStar5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#star-5_svg__a)",
    d: "M9.603 1.817a1 1 0 0 1 1.794 0l2.25 4.56a1 1 0 0 0 .753.547l5.032.73a1 1 0 0 1 .554 1.707l-3.641 3.549a1 1 0 0 0-.288.885l.86 5.012a1 1 0 0 1-1.45 1.054l-4.502-2.366a1 1 0 0 0-.93 0L5.534 19.86a1 1 0 0 1-1.451-1.054l.86-5.012a1 1 0 0 0-.288-.885L1.014 9.36a1 1 0 0 1 .554-1.705L6.6 6.924a1 1 0 0 0 .753-.547z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "star-5_svg__a",
    x1: -1,
    x2: 22,
    y1: 23,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })))));
};
export default SvgStar5;